export const GTM_ID = 'GTM-PJM6ZM';
export const GTM_DATA_LAYER_NAME = 'dataLayer';

export const APPLICATION_TYPES = ['bridge', 'credit', 'pre_approval', 'rental', 'infomration', 'broker'];
export const APPLICATION_RENTAL_LEAD_STEPS = ['property', 'borrower', 'complete'];
export const APPLICATION_BRIDGE_LEAD_STEPS = ['property', 'complete'];
